<template>
  <div>
    <epi-modal :opening-event-name="openingEventName" title="권한 목록">
      <template v-slot:body>
        <span>센터 권한</span>

        <div class="accordion" id="permissionAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button"
                data-bs-toggle="collapse"
                data-bs-target="#permission1"
              >
                직원상담사
              </button>
            </h2>
            <div
              class="accordion-collapse collapse show"
              id="permission1"
              data-bs-parent="#permissionAccordion"
            >
              <div class="accordion-body">
                <div class="vstack gap-3">
                  <div>
                    <label class="form-label">권한</label>
                    <input
                      type="text"
                      class="form-control"
                      value="직원상담사"
                    />
                  </div>
                  <div class="vstack gap-1">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" />
                        전체 예약 화면을 볼 수 있다
                      </label>
                    </div>

                    <div class="form-check ms-3">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" />
                        전체 예약 화면에서 추가, 수정 가능하다
                      </label>
                    </div>

                    <div class="form-check">
                      <label class="form-check-label disabled">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          disabled
                        />
                        본인의 예약화면만 볼 수 있다
                      </label>
                    </div>

                    <div class="form-check ms-3">
                      <label class="form-check-label disabled">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          disabled
                        />
                        본인의 예약 화면에서 추가, 수정 가능하다
                      </label>
                    </div>

                    <div class="form-check" v-for="i in 50" :key="i">
                      <label class="form-check-label disabled">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          disabled
                        />
                        권한 이름
                      </label>
                    </div>

                    <div class="d-flex justify-content-end">
                      <button class="btn btn-primary">수정</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#permission2"
              >
                프론트데스크
              </button>
            </h2>
            <div
              class="accordion-collapse collapse"
              id="permission2"
              data-bs-parent="#permissionAccordion"
            >
              <div class="accordion-body">
                <div class="vstack gap-3">
                  <div>
                    <label class="form-label">권한</label>
                    <input
                      type="text"
                      class="form-control"
                      value="프론트데스크"
                    />
                  </div>
                  <div class="vstack gap-1">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" />
                        전체 예약 화면을 볼 수 있다
                      </label>
                    </div>

                    <div class="form-check ms-3">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" />
                        전체 예약 화면에서 추가, 수정 가능하다
                      </label>
                    </div>

                    <div class="form-check">
                      <label class="form-check-label disabled">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          disabled
                        />
                        본인의 예약화면만 볼 수 있다
                      </label>
                    </div>

                    <div class="form-check ms-3">
                      <label class="form-check-label disabled">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          disabled
                        />
                        본인의 예약 화면에서 추가, 수정 가능하다
                      </label>
                    </div>

                    <div class="d-flex justify-content-end">
                      <button class="btn btn-primary">수정</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button collapsed"
                data-bs-toggle="collapse"
                data-bs-target="#permission3"
              >
                부원장
              </button>
            </h2>
            <div
              class="accordion-collapse collapse"
              id="permission3"
              data-bs-parent="#permissionAccordion"
            >
              <div class="accordion-body">
                <div class="vstack gap-3">
                  <div>
                    <label class="form-label">권한</label>
                    <input type="text" class="form-control" value="부원장" />
                  </div>
                  <div class="vstack gap-1">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" />
                        전체 예약 화면을 볼 수 있다
                      </label>
                    </div>

                    <div class="form-check ms-3">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" />
                        전체 예약 화면에서 추가, 수정 가능하다
                      </label>
                    </div>

                    <div class="form-check">
                      <label class="form-check-label disabled">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          disabled
                        />
                        본인의 예약화면만 볼 수 있다
                      </label>
                    </div>

                    <div class="form-check ms-3">
                      <label class="form-check-label disabled">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          disabled
                        />
                        본인의 예약 화면에서 추가, 수정 가능하다
                      </label>
                    </div>

                    <div class="d-flex justify-content-end">
                      <button class="btn btn-primary">수정</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div class="hstack gap-2 justify-content-end">
          <button class="btn btn-light">권한 추가</button>
          <button class="btn btn-light">닫기</button>
        </div>
      </template>
    </epi-modal>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "PermissionModal",
  data() {
    return {
      openingEventName: EventName.PermissionModalOpening,
    };
  },
};
</script>

<style lang="stylus" scoped>
label.disabled
  color #cfd3d6
</style>
